module.exports = __webpack_public_path__ + "static/parade-2020-house49-d625a415bf9c98f80c4c5ea811f33a1e.jpg";